import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Icon } from '../Icon';
import styles from './TooltipTrigger.module.css';
import { TooltipTriggerProps } from './types';
const TooltipTrigger = t0 => {
  const $ = _c(8);
  const {
    type: t1,
    title: t2,
    className
  } = t0;
  const type = t1 === undefined ? "question" : t1;
  const title = t2 === undefined ? "More information" : t2;
  let t3;
  if ($[0] !== className) {
    t3 = classNames(styles.tooltipTrigger, className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== title || $[3] !== type) {
    t4 = <Icon name={type} title={title} />;
    $[2] = title;
    $[3] = type;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <button className={t3} type="button">{t4}</button>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default TooltipTrigger;